import useContextForm from './useContextForm';

export const withFormConfig = (formContext, Component, loader = null) => (props) => {
    const formConfig = useContextForm(formContext);
    
    if (formConfig === undefined) {
        return loader;
    }
    
    return <Component {...props} formConfig={formConfig} />;
}